module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Passwordrecovery":{"widgets.passwordRecovery.container":[{"value":".forgotform_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Passwordrecovery","_fox_":1}]},"~.SitePage_Passwordrecovery #passwordRecovery ~.Dialog":{"dialog.dialogClass":[{"value":"mc-site-common-popup","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Passwordrecovery #passwordRecovery ~.Dialog","_fox_":1}],"dialog.width":[{"value":"385px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.SitePage_Passwordrecovery #passwordRecovery ~.Dialog","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/sitepage/passwordRecovery.js
// module id = 1158
// module chunks = 4